import axios from "axios";
import { ISignUpRequest } from "app/api/types/Auth";

export default (data: ISignUpRequest) =>
  axios.post(`${process.env.REACT_APP_API_HOST}/auth/signup`, data);
